import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DocumentService } from 'src/app/shared/service/document.service';
import { NotificationService } from 'src/app/shared/service/notification.service';

@Component({
  selector: 'app-upload-personal-document',
  templateUrl: './upload-personal-document.component.html'
})
export class UploadPersonalDocumentComponent {
  constructor(public dialogRef: MatDialogRef<UploadPersonalDocumentComponent>,
    @Inject(MAT_DIALOG_DATA) public memberId: number,
    private _documentService: DocumentService,
    private _notification: NotificationService,
    private _translate: TranslateService) { }
  @ViewChild('fileInput') fileInput: any;
  uploading = false;
  uploaded = false;
  documentName: string;

  uploadPersonalFile() {
    this.uploading = true;
    const fi = this.fileInput.nativeElement;
    if (fi.files && fi.files[0]) {
      const fileToUpload = fi.files[0];
      this._documentService
        .uploadPersonalFile(fileToUpload, this.documentName, this.memberId)
        .subscribe(() => {
          this._notification.showSuccessMessage(this._translate.instant('Message.UpdatedSuccess'));
          this.uploading = false;
          this.uploaded = true;
        }).add(() => this.uploading = false);
    }
  }

}
